<template>
  <div>
    <v-layout wrap align-center justify-center
      ><v-flex xs12 sm4>
        <h1 style="text-align: center">Add-on Management</h1>
      </v-flex>
      <v-btn
        class="hidden-xs-only"
        :disabled="dialog == true"
        absolute
        fab
        flat
        right
        @click="openDialog()"
        style="top: 10px; background-color: #fddf00; width: 50px; height: 50px"
      >
        <v-icon color="black" style="font-size: 35px">add</v-icon>
      </v-btn>
    </v-layout>
    <v-card class="my-3">
      <div style="background-color: #f5f5f5">
        <v-layout row justify-end>
          <v-flex xs12 sm4>
            <v-toolbar dense flat>
              <v-text-field
                v-model="textSearch"
                prepend-icon="search"
                label="Search Add-on name"
                single-line
                hide-details
                style="padding: 0"
              ></v-text-field>
            </v-toolbar>
          </v-flex>
        </v-layout>
      </div>
      <v-data-table
        :headers="headers"
        :items="addon_list_filter"
        class="elevation-0"
        :loading="isLoading"
      >
        <template v-slot:items="props">
          <td>
            {{ addon_list_filter.indexOf(props.item) + 1 }}
          </td>
          <td
            class="text-xs-center"
            style="white-space: nowrap; font-weight: 600"
          >
            {{ props.item.add_on_name_th }}
          </td>
          <td
            class="text-xs-center"
            style="white-space: nowrap; font-weight: 600"
          >
            {{ props.item.add_on_name_en }}
          </td>
          <td
            class="text-xs-center"
            style="white-space: nowrap; font-weight: 600"
          >
            {{ props.item.add_on_price }}
            {{ props.item.add_on_price_type == 1 ? "THB" : "%" }}
          </td>
          <td
            class="text-xs-center"
            style="white-space: nowrap"
            v-if="
              !props.item.add_on_stores ||
              props.item.add_on_stores.length == 0 ||
              props.item.add_on_stores[0] == 0
            "
          >
            <span
              style="
                background-color: #fddf00;
                border-radius: 20px;
                font-size: 12px;
                font-weight: 600;
              "
              class="py-1 px-2"
              >All Store</span
            >
          </td>
          <td v-else-if="isLoadingStore == true">
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </td>
          <td
            class="text-xs-center"
            style="white-space: nowrap; font-weight: 600"
            v-else
          >
            <ul>
              <li
                v-for="(store_id, index) in props.item.add_on_stores.slice(
                  0,
                  5
                )"
                :key="index"
              >
                <span> {{ storeName(store_id) }}</span>
              </li>
            </ul>
            <span v-if="props.item.add_on_stores.length > 5">....</span>
          </td>
          <td
            class="text-xs-center"
            style="white-space: nowrap; font-weight: 600"
          >
            <v-icon color="success" v-if="props.item.add_on_required"
              >check</v-icon
            >
            <v-icon v-else color="error">close</v-icon>
          </td>
          <td
            style="display: flex; align-items: center; justify-content: center"
          >
            <v-switch
              v-model="props.item.add_on_status"
              hide-details
              color="primary"
              :true-value="1"
              :false-value="0"
              style="max-width: 50px"
              @change="changeStatus(props.item)"
            ></v-switch>
          </td>
          <td class="text-xs-center">
            <v-btn
              icon
              @click="toEdit(props.item, addon_list_filter.indexOf(props.item))"
              ><v-icon>edit</v-icon></v-btn
            >
            <v-btn icon @click="toDelete(props.item, props.index)"
              ><v-icon>delete</v-icon></v-btn
            >
          </td>
        </template>
      </v-data-table>
      <v-btn
        class="hidden-sm-and-up"
        fab
        fixed
        bottom
        right
        color="primary"
        @click="openDialog()"
        ><v-icon color="black">add</v-icon></v-btn
      >
    </v-card>
    <formDialog
      :dialog="dialog"
      @onClosed="closeDialog($event)"
      @onSaved="submitForm($event)"
      :editedIndex="editedIndex"
      :editForm="editForm"
    />
  </div>
</template>

<script>
import formDialog from "@/components/back-office/Food/CreateAddonForm.vue";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      headers: [
        {
          text: "No.",
          align: "left",
          sortable: false,
          value: "",
        },
        {
          align: "center",
          text: "Add-on name(TH)",
          sortable: false,
          value: "add_on_name_th",
        },
        {
          align: "center",
          text: "Add-on name(EN)",
          sortable: false,
          value: "add_on_name_en",
        },
        {
          align: "center",
          text: "Price",
          sortable: false,
          value: "add_on_price",
        },
        {
          align: "center",
          text: "Including Store",
          sortable: false,
          value: "add_on_price",
        },
        {
          align: "center",
          text: "Required ?",
          sortable: false,
          value: "add_on_price",
        },
        { align: "center", text: "Status", sortable: false, value: "" },
        { align: "center", text: "Action", sortable: false, value: "" },
      ],
      editedIndex: 0,
      isLoading: false,
      textSearch: "",
      dialog: false,
      form: {
        adddon_th: "",
        adddon_en: "",
        province: null,
        amount: "",
        price_type: null,
        select_store: [0],
      },
      editForm: {},
      edit_id: null,
      isLoading: false,
      isLoadingStore: false,
    };
  },
  async created() {
    this.isLoading = true;
    await this.getAddon(this.$route.params.province);
    this.isLoading = false;
    await this.fetchStoreList();
    await this.$store.dispatch(
      "fetchOrderListBack/fetchOrderCountEachProvince"
    );
  },

  components: {
    formDialog,
  },
  methods: {
    ...mapActions({
      getAddon: "fetchAddonFood/getAddonList",
      ChangeStatusAddon: "fetchAddonFood/ChangeStatusAddon",
      delete_food_addon: "fetchAddonFood/delete_food_addon",
      create_addon_food: "fetchAddonFood/create_addon_food",
      edit_addon_food: "fetchAddonFood/edit_addon_food",
    }),
    async fetchStoreList() {
      this.isLoadingStore = true;
      await this.$store.dispatch("fetchStoreBack/getStoreList");
      this.isLoadingStore = false;
    },
    toEdit(item, index) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.editedIndex = 1;
      this.dialog = true;
      let payload = {
        add_on_id: this.selectedItem.add_on_id,
        add_on_name_th: this.selectedItem.add_on_name_th,
        add_on_name_en: this.selectedItem.add_on_name_en,
        add_on_status: this.selectedItem.add_on_status,
        add_on_province: this.selectedItem.add_on_province,
        add_on_stores: this.selectedItem.add_on_stores,
        add_on_price: this.selectedItem.add_on_price,
        add_on_price_type: this.selectedItem.add_on_price_type,
        add_on_set_price_type: this.selectedItem.add_on_set_price_type,
        create_at: this.selectedItem.create_at,
        update_at: this.selectedItem.update_at,
        delete_at: this.selectedItem.delete_at,
        add_on_required: this.selectedItem.add_on_required,
      };
      this.edit_id = index;
      this.editForm = payload;
    },
    closeDialog(item) {
      this.dialog = item;
      this.editedIndex = 0;
    },
    openDialog() {
      this.editForm = {
        add_on_stores: [],
      };
      this.dialog = true;
    },
    async submitForm(event) {
      let form_type = event.formType;
      let payload = event.payload;
      if (form_type == 0) {
        let response = await this.create_addon_food({
          province: this.$route.params.province,
          payload,
        });
        if (response == false) {
          alert("can not create add on");
        }
      } else {
        Object.assign(payload, {
          add_on_id: this.addon_list_filter[this.edit_id].add_on_id,
        });
        let response = await this.edit_addon_food({
          province: this.$route.params.province,
          payload,
        });
        if (response == false) {
          alert("can not edit add on");
        }
      }
    },
    async changeStatus(item) {
      let payload = JSON.parse(JSON.stringify(item));
      let body = {
        add_on_id: payload.add_on_id,
        add_on_status: payload.add_on_status,
      };
      let response = await this.ChangeStatusAddon({
        province: this.$route.params.province,
        body,
      });
      if (response == false) {
        alert("Error");
        return;
      }
    },
    async toDelete(item) {
      let payload = JSON.parse(JSON.stringify(item));
      confirm("Are you sure you want to delete this Add-on") &&
        (await this.delete_food_addon({
          province: this.$route.params.province,
          payload,
        }));
    },
    storeName(store_id) {
      let storeItem = this.storeListFoodAddOn.find(
        (val) => val.store_id == store_id
      );
      return storeItem ? storeItem.store_name_th : "";
    },
  },
  computed: {
    ...mapState({
      addon_list: (state) => state.fetchAddonFood.addon_list,
    }),
    ...mapGetters({
      storeListFoodAddOn: "fetchStoreBack/storeListFoodAddOn",
    }),
    addon_list_filter() {
      return this.addon_list.filter(
        (val) =>
          val.add_on_name_th
            .toLowerCase()
            .includes(this.textSearch.toLowerCase()) ||
          val.add_on_name_en
            .toLowerCase()
            .includes(this.textSearch.toLowerCase())
      );
    },
  },
};
</script>

<style scoped>
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
}
.lds-ellipsis div {
  position: absolute;
  top: 10px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: grey;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
